import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  COMPANY_NAME,
  SECTOR,
  SEER_COMPETITOR,
  SIZE_MAX,
  SIZE_MIN,
  STOCK_TICKER,
  WEBSITE,
} from 'constants/formFields';
import { DEFAULT_OPTION } from 'constants/general';
import { competitorCreateSchema } from 'utils/validators';

import type { TCompetitorCreateSchema } from 'utils/validators';
import type ICreateCompetitorForm from '../interfaces/ICreateCompetitorForm';

const useCreateCompetitorForm = ({ isPageLoading }: ICreateCompetitorForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading, errors },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TCompetitorCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(competitorCreateSchema),
    defaultValues: {
      [COMPANY_NAME]: DEFAULT_OPTION,
      [STOCK_TICKER]: [],
      [WEBSITE]: '',
      [SECTOR]: [],
      [SEER_COMPETITOR]: DEFAULT_OPTION,
      [SIZE_MIN]: '',
      [SIZE_MAX]: '',
    },
  });

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    getValues,
    resetField,
    errors,
  };
};

export default useCreateCompetitorForm;
